import { useTranslation } from "react-i18next";
import { LinkListType } from "../../utils/models/CommonTypes";
import { Link } from "@sentara-health/optimahealth_web";
import React, { useState, useEffect } from "react";
import { useFeatureFlag } from "../../providers/featureFlag/FeatureFlagProvider";
import { FeatureFlagKey } from "../../providers/featureFlag/FeatureFlagProvider.types";

type Props = {
  setIsOpen?: (v: boolean) => void;
  list: Array<LinkListType>;
  setInitialActiveIndex: (v: number) => void;
  no: number;
  isActive?: boolean;
};

export const MenuLinks = (props: Props) => {
  const { setIsOpen = () => {} } = props;
  const { t } = useTranslation();
  const { list, setInitialActiveIndex, no } = props;
  const [listClassName, setListClassName] = useState("");
  useEffect(() => {
    setListClassName(window.location.pathname);
  }, [window.location.pathname, window.location.search]);

  const featureFlags = { 
      wellsFargoFlag: useFeatureFlag(FeatureFlagKey.WellsFargoSSO),
      billingStatementsFlag: useFeatureFlag(FeatureFlagKey.BillingStatements)
  };

  // Filter the list based on the LD feature flags
  const filteredList = list.filter((item: LinkListType) => {
    // Check if the item is "PayMonthlyInvoice" and WellsFargoSSO is enabled
    if (item.id === "lnkPayMonthlyInvoice" && !featureFlags.wellsFargoFlag) {
      return false;
    }
    // Check if the item is "BillingStatements" and BillingStatements feature flag is enabled
    if (item.id === "lnkOrderMemberIdCard" && !featureFlags.billingStatementsFlag) {
      return false;
    }
    return true;
  });
 
  
  return (
    <ul className="list-group link-list">
      {filteredList.map((item: LinkListType) => (
        <li className="list-group-item list-group-item-action">
          <Link
            className={`${listClassName === item.to ? "active-link-list" : ""}`}
            to={item.to}
            variant="sidebarmenu_link"
            target={item.target}
            data-testid={item.id}
            onClick={() => setIsOpen(false)}
          >
            {t(item.title)}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default MenuLinks;
